export const RegistrationProtocols = Object.freeze({
  OIDC: "openid_connect",
  SAML: "saml",
  NONE: "none",
});
